export default {
  step3:[
    {
      id:15,
      step: 3,
      stepJp: "テクスチャー",
      name: "シンプル",
      property: "texture",
      val: "simple",
      summary:"表面に凹凸がなくシンプルなもの。「ブラシ仕上げ」が可能なのはシンプルのみです。",
    },
    {
      id:16,
      step: 3,
      stepJp: "テクスチャー",
      name: "ハンマー",
      property: "texture",
      val: "hammer",
      summary:"ハンマーでたたいて付ける、美しい槌目のテクスチャー。使い込むと槌目はなだらかに変化します。",
    },
    {
      id:17,
      step: 3,
      stepJp: "テクスチャー",
      name: "アンティーク",
      property: "texture",
      val: "antique",
      summary:"ヤスリ跡を生かして仕上げた、ビンテージ感のあるテクスチャー。\n" + 
      "※一つ一つ風合いが異なり、シミュレーションが難しいテクスチャーです。実物とは見え方が異なります。",
    },
    {
      id:18,
      step: 3,
      stepJp: "テクスチャー",
      name: "グリッター",
      property: "texture",
      val: "glitter",
      summary:"細やかな槌目を磨き仕上げた、湖面の煌めきのようなテクスチャー（光沢仕上げがおすすめです）",
    },
    {
      id:19,
      step: 3,
      stepJp: "テクスチャー",
      name: "ストーン",
      property: "texture",
      val: "stone",
      summary:"タガネで岩肌のような質感を出したテクスチャー/　部分的に入れることも可能",
    },
    {
      id:20,
      step: 3,
      stepJp: "テクスチャー",
      name: "アース",
      property: "texture",
      val: "earth",
      summary:"大地をイメージ。特殊なハンマーで傷を入れたビンテージ感のあるテクスチャー\n" +
      "※一つ一つ風合いが異なり、シミュレーションが難しいテクスチャーです。実物とは見え方が異なります。",
    },
    {
      id:2023,
      step: 3,
      stepJp: "テクスチャー",
      name: "リネン",
      property: "texture",
      val: "linen",
      summary:"リネン布のような質感の繊細なテクスチャー ご使用によりつるっとしてきます。",
    },
  ]
}
